import React, { useState } from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { InputMask } from '../../../../CommonComponents/OPL/Input/InputMask';
import { EditableField } from '../../components/EditableField/EditableField';
import { DraftAccountDTO } from '../../AccountOpening.meta';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { SpaceProps } from '../../../../theme/styledProps';

interface Props extends SpaceProps {
  isReview?: boolean;
  fieldName: string;
  draftAccount: DraftAccountDTO;
}

export const Ssn: React.FC<Props> = ({ fieldName, isReview, draftAccount, ...rest }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const [isEditing, setIsEditing] = useState(!isReview);

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        {get(draftAccount, fieldName)}
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <InputMask
        {...register(fieldName)}
        label={isReview ? undefined : 'SSN'}
        type="text"
        mask="999-99-9999"
        placeholder="XXX - XX - XXXX"
        leftIcon="far fa-address-card"
        formVariant={get(errors, fieldName) ? 'error' : undefined}
        helperText={(get(errors, fieldName) as FieldError | undefined)?.message}
        aria-label="SSN"
      />
    </Box>
  );
};
